import { useState } from 'react';
import { Link } from 'react-router-dom';
import { createClassroom } from '../../lib/api';
import LanguagePicker from './LanguagePicker';
import { useClassroom } from '../../state/Classroom';

export default function CreateClassForm({ onCreated }: { onCreated?: () => void }) {
  const { refresh, setActiveId, canCreate } = useClassroom();
  const [name, setName] = useState('');
  const [language, setLanguage] = useState('es');
  const [nativeLanguage, setNativeLanguage] = useState('en');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const create = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      if (language === nativeLanguage) throw new Error('Pick two different languages.');
      const c = await createClassroom(name.trim(), language, nativeLanguage);
      setActiveId(c.id);
      setName('');
      await refresh();
      onCreated?.();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  if (!canCreate) {
    return <div className="notice">Your free trial has ended. <Link to="/billing">Subscribe</Link> to make new classes.</div>;
  }

  return (
    <form className="panel" onSubmit={create}>
      <div className="field">
        <label htmlFor="cname">Class name</label>
        <input
          id="cname" required maxLength={80} placeholder="3rd period, level 2"
          value={name} onChange={e => setName(e.target.value)}
        />
      </div>
      <LanguagePicker language={language} nativeLanguage={nativeLanguage}
        onChange={(l, n) => { setLanguage(l); setNativeLanguage(n); }} />
      {error && <div className="notice bad small" style={{ marginBottom: 14 }}>{error}</div>}
      <button className="primary" disabled={busy || !name.trim()}>{busy ? 'Creating…' : 'Create class'}</button>
    </form>
  );
}
